import { useNavigate } from "react-router-dom";
import { Users, Swords, MapPin, Plane } from "lucide-react";

const ACTIONS = [
  { label: "Find Players", icon: Users, to: "/play", testid: "action-find-players", color: "#4A90E2" },
  { label: "Find a Game", icon: Swords, to: "/play", testid: "action-find-game", color: "#005F19" },
  { label: "Find Courts", icon: MapPin, to: "/courts", testid: "action-find-courts", color: "#0E395F" },
  { label: "Traveling", icon: Plane, to: "/courts?travel=1", testid: "action-traveling", color: "#F5B700" },
];

export default function QuickActions() {
  const navigate = useNavigate();
  return (
    <section data-testid="quick-actions-grid">
      <div className="grid grid-cols-4 gap-3">
        {ACTIONS.map((a) => (
          <button
            key={a.label}
            data-testid={a.testid}
            onClick={() => navigate(a.to)}
            className="group rounded-2xl bg-white border border-[#0E395F]/10 p-4 flex flex-col items-center gap-2 hover:-translate-y-0.5 hover:shadow-md transition-all"
          >
            <span className="grid place-items-center h-11 w-11 rounded-xl" style={{ backgroundColor: a.color + "1A", color: a.color }}>
              <a.icon size={20} />
            </span>
            <span className="text-xs font-bold pv-text-dark text-center leading-tight">{a.label}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
